import { useEffect, useState } from "react"
import { DiscoverDomain, Technology } from "../types/discover"
import { KeyValue, KeyValueDescription, KeyValueItem, KeyValueTitle } from "../ui/key-value"

export function DomainSidepanelTechnologies({ domain }: { domain: DiscoverDomain }) {
  const [technologies, setTechnologies] = useState<Technology[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    fetch(`/search/${domain.value}/technologies.json`)
      .then((response) => response.json())
      .then((data) => {
        setTechnologies(data.technologies)
        setIsLoading(false)
      })
  }, [domain.value])

  if (isLoading) {
    return <div>{i18n.t("js.discover.company_details.technologies.loading")}</div>
  }

  const groupedTechnologies = technologies.reduce(
    (acc, technology) => {
      acc[technology.category] = acc[technology.category] || []
      acc[technology.category].push(technology)
      return acc
    },
    {} as Record<string, Technology[]>,
  )

  return (
    <section className="lead-details-content">
      <div className="lead-details-content__header">
        <h2 className="lead-details-content__title">
          {i18n.t("js.discover.company_details.technologies.title", {
            domain: domain.value,
          })}
        </h2>
        <small className="grey">
          {i18n.t("js.discover.company_details.technologies.powered_by")}{" "}
          <a href="https://techlookup.com" target="_blank" rel="noopener noreferrer">
            TechLookup
          </a>
        </small>
      </div>

      <KeyValue>
        {Object.entries(groupedTechnologies).map(([category, technologies]) => (
          <KeyValueItem key={category}>
            <KeyValueTitle>{i18n.t(`js.discover.company_details.technology_category.${category}`)}</KeyValueTitle>
            {technologies.map((technology) => (
              <KeyValueDescription key={technology.id}>
                <div className="ds-tech__link">
                  <img
                    src={`https://logos.hunter.io/${new URL(technology.website).host}`}
                    className="ds-company__logo"
                  />
                  {technology.display_name}
                </div>
              </KeyValueDescription>
            ))}
          </KeyValueItem>
        ))}
      </KeyValue>
    </section>
  )
}
